import { AxisTickProps } from '@nivo/axes'
import { Line, LineSvgProps } from '@nivo/line'
import { DSTooltip } from '@repo/design-system/index'
import { QIcon_question_outline } from '@repo/icons/index'
import { ACTIVE_CHART_COLOR, chartWidth } from '../../../../modules/consts/caf'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { ICON_QUESTION_GRAY } from '../../../../modules/svg/svg'
import { COLORS } from '../../../../modules/vars'
import { useWebviewModal } from '../common/Modal/WebviewModal'
import CommonLegendList, { LEGEND_SHAPE } from './common/CommonLegendList'
import { CustomXTick } from './common/CustomXYTick'

const theme = {
  grid: {
    line: {
      stroke: 'rgba(226, 233, 242, 1)',
      strokeWidth: 1,
      strokeDasharray: '2, 2', // 점선 스타일
    },
  },
}
const X_AXIS_VISIBLE_MAX = 36
const Y_AXIS_INTERVAL = 0.5
const CHART_HEIGHT = 240
const CHART_STYLE: Partial<LineSvgProps> = {
  curve: 'linear',
  margin: {
    top: 12,
    left: 0,
    right: 5,
    bottom: 23,
  },
  role: 'presentation',
  colors: [ACTIVE_CHART_COLOR],
  enablePoints: true,
  pointBorderWidth: 2,
  pointColor: 'white',
  animate: true,
  pointSize: 7,
  gridYValues: [0, 0.25, 0.5, 0.75, 1],
  gridXValues: [-1, 10, 20, 30, 40],
  enableGridX: true,
  enableGridY: true,
  theme: theme,
}

interface Props {
  data: any[]
  marker?: boolean
  dataKey: string
  indexBy: string
  options?: Partial<LineSvgProps>
  pl?: number
}
const ProsodyChart = ({ data, marker, dataKey, indexBy, options = {}, pl = 0 }: Props) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  const FLUENCY_LABEL_LIST = [
    { label: t(n_caf.pronunciation.graph_legend2), color: 'rgba(63, 61, 136, 1)', type: LEGEND_SHAPE.round },
  ]

  const webviewPopup = useWebviewModal()
  const handleClickTooltip = () => {
    if (isMobile) {
      webviewPopup.show({
        id: 'epc_popup',
        title: t(n_caf.fluency.s_modal_title),
        body: t(n_caf.fluency.s_modal_subtitle),
      })
    }
  }

  const graphData = [
    {
      id: 1,
      color: ACTIVE_CHART_COLOR,
      data:
        data.map((item) => {
          return {
            x: item[indexBy] || 0,
            y: Number(item[dataKey]) || 0,
            color: ACTIVE_CHART_COLOR,
          }
        }) || [],
    },
  ]
  // X Axis
  // 데이터가 10개 미만인 경우 x축 라벨을 표시하지 않는다.
  if (!Array.isArray(graphData[0]?.data)) return null

  const yRangeMax = 1.0
  const yRange = [0, 0.5, 1]
  const dataWidth = chartWidth - CHART_STYLE.margin.left - CHART_STYLE.margin.right
  const eachWidth = Math.floor(dataWidth / X_AXIS_VISIBLE_MAX)
  const width = eachWidth * data.length
  console.log(eachWidth, width, 'width!')
  console.log('graphData!', graphData)
  return (
    <>
      {isMobile ? (
        <div className="flex h-[240px] w-full flex-row ">
          <div className={`h-full pl-[${pl}px] flex flex-col justify-between pr-[9px]  text-[12px] text-gray-500`}>
            {yRange?.reverse()?.map((y) => (
              <div key={y}>{y}</div>
            ))}
          </div>
          <div className="no-scrollbar overflow-x-auto overflow-y-hidden">
            <Line
              {...CHART_STYLE}
              height={CHART_HEIGHT}
              width={width}
              data={graphData}
              axisLeft={{
                tickSize: 0,
                tickValues: yRange,
                tickPadding: 20,
                renderTick: () => <></>,
              }}
              axisBottom={{
                tickSize: 0,
                legendPosition: 'start',
                tickPadding: 10,
                renderTick: (tick: AxisTickProps<string>) => <CustomXTick tick={tick} yGap={17} />,
              }}
              yScale={{ type: 'linear', min: 0, max: 1 }}
              xScale={{
                type: 'linear',
                min: -1,
                max:
                  data.length <= 10
                    ? 10
                    : graphData[0]?.data?.length === X_AXIS_VISIBLE_MAX
                    ? X_AXIS_VISIBLE_MAX
                    : graphData[0]?.data?.length + 1,
              }}
              layers={['grid', 'markers', 'areas', 'lines', 'slices', 'points', 'legends', 'mesh', 'axes']}
              //   markers={
              //     marker
              //       ? [
              //           {
              //             axis: 'y', // x축에 대한 마커
              //             value: Y_MARKER_VALUE, // 마커의 위치 (x값)
              //             lineStyle: { stroke: MARKER_COLOR, strokeWidth: 1 }, // 마커의 선 스타일
              //           },
              //         ]
              //       : []
              //   }
              pointBorderColor={(object) => {
                return ACTIVE_CHART_COLOR
              }}
              {...options}
            />
          </div>
        </div>
      ) : (
        <div className="flex h-[240px] w-full flex-row ">
          <div className={`h-full pl-[${pl}px] flex flex-col justify-between pr-[9px]  text-[12px] text-gray-400`}>
            {yRange?.reverse()?.map((y) => (
              <div key={y}>{y}</div>
            ))}
          </div>
          <div className="no-scrollbar overflow-x-auto overflow-y-hidden">
            <Line
              {...CHART_STYLE}
              height={CHART_HEIGHT}
              width={width}
              data={graphData}
              axisLeft={{
                tickSize: 0,
                tickValues: yRange,
                tickPadding: 20,
                renderTick: () => <></>,
              }}
              axisBottom={{
                tickSize: 0,
                legendPosition: 'start',
                tickPadding: 10,
                renderTick: (tick: AxisTickProps<string>) => (
                  <CustomXTick tick={tick} yGap={17} color={COLORS.GRAY400} />
                ),
              }}
              yScale={{ type: 'linear', min: 0, max: 1 }}
              xScale={{
                type: 'linear',
                min: -1,
                max:
                  data.length <= 10
                    ? 10
                    : graphData[0]?.data?.length === X_AXIS_VISIBLE_MAX
                    ? X_AXIS_VISIBLE_MAX
                    : graphData[0]?.data?.length + 1,
              }}
              layers={['grid', 'markers', 'areas', 'lines', 'slices', 'points', 'legends', 'mesh', 'axes']}
              pointBorderColor={(object) => {
                return ACTIVE_CHART_COLOR
              }}
              {...options}
            />
          </div>
        </div>
      )}
      {isMobile ? (
        <div
          className="text-h5 mt-[5px] flex items-center justify-center gap-[6px] text-center font-medium tracking-tight text-gray-600"
          onClick={handleClickTooltip}
        >
          {t(n_caf.fluency.graph_sentence)}
          <img src={ICON_QUESTION_GRAY} width={16} height={16} alt="question" />
        </div>
      ) : (
        <div className="mt-[8px] flex flex-row items-center justify-center">
          <div className="flex cursor-pointer flex-row items-center justify-start">
            <span className="mr-[2px] text-[14px] text-gray-600">{t(n_caf.fluency.graph_sentence)}</span>
            <DSTooltip
              place="bottom"
              isMultiline={true}
              isOpenOnClick={true}
              triggerComponent={
                <QIcon_question_outline fill={COLORS.GRAY600} width={16} height={16} className="mb-[1px]" />
              }
              contentComponent={t(n_caf.fluency.s_modal_subtitle)}
            />
          </div>
        </div>
      )}

      {/* legend - 개별 하이라이트 : Pronunciation 상세 페이지 */}
      <CommonLegendList list={FLUENCY_LABEL_LIST} />
    </>
  )
}
export default ProsodyChart
